<template>
  <div class="home">
    <HomeAd v-if="adSource === 'instagram'" />
    <HomeM v-else/>
    <!-- <HomeD v-if="this.$store.state.device == 'desktop'" />
    <HomeM v-else/> -->
  </div>
</template>

<script>
// import HomeD from '../components/desktop/Home.vue'
import HomeM from '../components/mobile/Home.vue'
import HomeAd from '../components/mobile/HomeAd.vue'
export default {
  name: 'home',

  components: {
    // HomeD,
    HomeM,
    HomeAd,
  },


  data () {
    return {
      adSource: 'n/a'
    }
  },
  mounted() {
    this.adSource = this.getParameterFromURL("source")
  },
  created () {
  
  },

  beforeDestroy () {
  },
  methods: {
    //Returns the value of a parameter existing in the page's URL or ' ' if not exists.
    getParameterFromURL:function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// HomeView.vue